import { render, staticRenderFns } from "./courseNav.vue?vue&type=template&id=6479cac4"
import script from "./courseNav.vue?vue&type=script&lang=js"
export * from "./courseNav.vue?vue&type=script&lang=js"
import style0 from "./courseNav.vue?vue&type=style&index=0&id=6479cac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports